import { Link, useLocation } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { ASSETS, SERVICES } from "@/lib/services";
import { openCookieSettings } from "@/components/CookieConsent";

export default function Footer() {
  const { t } = useContent();
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <footer className="bg-ink-800 text-bone-50 mt-32" data-testid="site-footer">
      <div className="section py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="VF" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-serif text-xl tracking-wide">Vasileios Filippidis</div>
              <div className="uppercase tracking-[0.28em] text-[10px] text-gold-500">Law Office</div>
            </div>
          </div>
          <p className="mt-8 text-bone-100/70 max-w-md leading-relaxed">
            {t("footer.tagline", "Legal Solutions for International Clients in Greece.")}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow !text-gold-500 mb-6">Practice</div>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="text-bone-100/80 hover:text-gold-500 transition-colors text-sm"
                  data-testid={`footer-service-${s.slug}`}
                >
                  {t(`service.${s.slug}.title`, s.slug)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow !text-gold-500 mb-6">Contact</div>
          <ul className="space-y-4 text-sm text-bone-100/80">
            <li className="flex gap-3">
              <i className="fa-solid fa-location-dot text-gold-500 mt-1" />
              <span data-testid="footer-address">{t("contact.address")}</span>
            </li>
            <li className="flex gap-3">
              <i className="fa-solid fa-envelope text-gold-500 mt-1" />
              <a href={`mailto:${t("contact.email")}`} className="hover:text-gold-500" data-testid="footer-email">
                {t("contact.email")}
              </a>
            </li>
            <li className="flex gap-3">
              <i className="fa-solid fa-phone text-gold-500 mt-1" />
              <a href={`tel:${t("contact.phone")}`} className="hover:text-gold-500" data-testid="footer-phone">
                {t("contact.phone")}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ink-600">
        <div className="section py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-bone-100/50">
          <span>{t("footer.copyright")}</span>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 justify-center md:justify-end">
            <Link to="/privacy-policy" className="hover:text-gold-500 transition-colors" data-testid="footer-privacy-link">
              {t("footer.privacy_link", "Privacy Policy")}
            </Link>
            <Link to="/cookie-policy" className="hover:text-gold-500 transition-colors" data-testid="footer-cookie-policy">
              {t("footer.cookie_link", "Cookie Policy")}
            </Link>
            <Link to="/terms-of-use" className="hover:text-gold-500 transition-colors" data-testid="footer-terms-link">
              {t("footer.terms_link", "Terms of Use")}
            </Link>
            <button
              onClick={openCookieSettings}
              className="hover:text-gold-500 transition-colors"
              data-testid="footer-cookie-settings"
            >
              Cookie settings
            </button>
            <Link to="/admin/login" className="hover:text-gold-500 transition-colors" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
